import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import { getStyledSecondaryColor, getStyledPrimaryColor } from "theme/palette"
import ShareIcon from "atoms/ShareIcon"

const BoxWrapper = styled.div`
  background: ${getStyledSecondaryColor()};
  border: 1px solid #bebebe;
  border-radius: 12px;
  display: flex;
  padding: 10px 0px;
  position: absolute;
  right: ${({ centerPosition }) => centerPosition ? "inherit" : "35px"};

  &:before {
    content: "";
    border-color: transparent #cccfd1;
    border-style: solid;
    border-width: 10px 0 10px 12px;
    bottom: auto;
    display: ${({ centerPosition }) => centerPosition ? "none" : "block"};
    right: -12px;
    position: absolute;
    top: 27px;
    width: 0;
  }

  &:after {
    border-color: transparent ${getStyledSecondaryColor()};
    border-style: solid;
    border-width: 9px 0 9px 10px;
    bottom: auto;
    content: "";
    display: ${({ centerPosition }) => centerPosition ? "none" : "block"};
    right: -10px;
    position: absolute;
    top: 28px;
    width: 0;
  }
`

const getTrackableURL = (url, medium, publisherId, storyId, escape = false) => {
  const utmContent = [publisherId, storyId].filter((val) => val).join("-")
  const params = [
    "utm_source=webplayer",
    `utm_medium=${medium}`,
    "utm_campaign=1",
    utmContent ? `utm_content=${utmContent}` : null,
  ].filter((val) => val).join("&")
  if (escape) return `${url}?${encodeURIComponent(params)}`
  return `${url}?${params}`
}

const getPublicationText = (name) =>
  encodeURIComponent(`Listen to the latest news${name ? ` from ${name}` : ""}.`)

const getPublicationTextWithURL = (name, url) =>
  encodeURIComponent(`Listen to the latest news${name ? ` from ${name}` : ""} - ${url}.`)

const getTwitterLink = (publisher, story) =>
  `https://twitter.com/intent/tweet?text=${getPublicationText(publisher.name)}&url=${getTrackableURL(story.shareUrl, "twitter", publisher.id, story.id, true)}`

const getFacebookLink = (publisher, story) =>
  `https://www.facebook.com/sharer/sharer.php?u=${getTrackableURL(story.shareUrl, "facebook", publisher.id, story.id)}`

const getEmailLink = (publisher, story) => {
  const trackableUrl = getTrackableURL(story.shareUrl, "email", publisher.id, story.id)
  return `mailto:?to=&subject=${getPublicationText(publisher.name)}&body=${getPublicationTextWithURL(publisher.name, trackableUrl)}`
}

const getSmsLink = (publisher, story) => {
  const userAgent = navigator.userAgent.toLowerCase()
  const trackableUrl = getTrackableURL(story.shareUrl, "sms", publisher.id, story.id, true)

  if (userAgent.indexOf("iphone") > -1 || userAgent.indexOf("ipad") > -1) {
    return `sms:&body=${getPublicationTextWithURL(publisher.name, trackableUrl)}`
  }
  return `sms:?body=${getPublicationTextWithURL(publisher.name, trackableUrl)}`
}

const ShareBox = ({
  theme, iconsTheme, url, publisher, story, centerPosition, onShareButtonClicked, ...rest
}) => (
  <BoxWrapper theme={theme} centerPosition={centerPosition}>
    <ShareIcon theme={iconsTheme === "coloured" ? iconsTheme : theme} onClick={onShareButtonClicked("facebook")} type='facebook' href={getFacebookLink(publisher, story)} target='_blank' rel='noopener noreferrer' />
    <ShareIcon theme={iconsTheme === "coloured" ? iconsTheme : theme} onClick={onShareButtonClicked("twitter")} type='twitter' href={getTwitterLink(publisher, story)} target='_blank' rel='noopener noreferrer' />
    <ShareIcon theme={iconsTheme === "coloured" ? iconsTheme : theme} onClick={onShareButtonClicked("mail")} type='mail' href={getEmailLink(publisher, story)} target='_blank' rel='noopener noreferrer' />
    <ShareIcon theme={iconsTheme === "coloured" ? iconsTheme : theme} onClick={onShareButtonClicked("sms")} type='sms' href={getSmsLink(publisher, story)} target='_blank' rel='noopener noreferrer' />
  </BoxWrapper>
)

ShareBox.defaultProps = {
  publisher: {
    id: "",
    name: "",
  },
  story: {
    id: "",
    shareUrl: "",
  },
}

ShareBox.propTypes = {
  centerPosition: PropTypes.bool,
  theme: PropTypes.oneOf(["light", "dark"]),
  iconsTheme: PropTypes.oneOf(["coloured", "inherit"]),
  url: PropTypes.string,
  publisher: PropTypes.shape({
    id: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    name: PropTypes.string,
  }),
  story: PropTypes.shape({
    id: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    shareUrl: PropTypes.string,
  }),
  onShareButtonClicked: PropTypes.func.isRequired,
}

export default ShareBox



// WEBPACK FOOTER //
// ./src/components/molecules/ShareBox/index.js